<template>
  <div style="min-height: 92vh">
    <h3>Areas de restaurante</h3>
    <uv-data-table
      :config="config"
      :data="departamentos"
      :pageRows="15"
      @buttonClick="dtButtonClick"
    ></uv-data-table>
    <modal ref="modalForm" v-model="showModal" :showFooter="false">
      <DepartamentoForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </DepartamentoForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../MainComponents/modal.vue";
import uvDataTable from "../MainComponents/DataTable.vue";
import DepartamentoForm from "../Restaurante/DepartamentosForm.vue";

export default {
  name: "DepartamentosCRUD",
  components: {
    modal,
    uvDataTable,
    DepartamentoForm,
  },
  props: [],
  data() {
    return {
      formIndex: 0,
      formHeight: 0,
      editMode: false,
      departamentos: [],
      editData: {},
      showModal: false,
      config: {
        selectableRow: true,
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Agregar area AYB",
            icon: "lni lni-plus",
            buttonId: "addDepartamento",
            require: false,
          },
          {
            text: "Editar area AYB",
            icon: "lni lni-pencil-alt",
            buttonId: "editDepartamento",
            require: true,
          },
          {
            text: "Administrar Mapas",
            icon: "lni lni-restaurant",
            buttonId: "adminAreas",
            require: true,
          },
          {
            text: "Eliminar area AYB",
            icon: "lni lni-trash",
            buttonId: "eliminarDepartamento",
            require: true,
          },
          {
            text: "Editar galería",
            icon: "lni lni-gallery",
            buttonId: "editarGaleria",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "Nombre",
            text: "Nombre",
            value: "Nombre",
          },
          {
            text: "Código",
            value: "Codigo",
          },
          {
            title: "Estatus",
            dataName: "Activo",
            text: "Estatus",
            value: "Activo",
            format: (row) => {
              return row.Activo
                ? '<span class="green--text">Activo</span>'
                : '<span class="red--text">Inactivo</span>';
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addDepartamento") {
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar Area AYB");
        this.showModal = true;
      } else if (buttonId == "editDepartamento") {
        const cashier = this.$pgsHelper.getById(
          this.departamentos,
          "Id",
          idSelected[0]
        );

        this.editMode = true;
        this.editData = cashier;
        this.$pgsHelper.log(this.editData);
        this.$refs.modalForm.setTitle(`Editar Area AYB`);
        this.showModal = true;
      } else if (buttonId == "eliminarDepartamento") {
        this.deleteDepartamento(idSelected[0]);
      } else if (buttonId == "adminAreas") {
        this.$router.push({ path: "areas/" + idSelected[0] });
      } else if (buttonId == "editarGaleria") {
        this.$router.push({ path: "galeria/" + idSelected[0] });
      }
    },
    optButtonClick() {},
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.addDepartamento(data);
      } else if (doAction == "EDIT") {
        this.editDepartamento(data);
      }
    },
    deleteDepartamento(Id) {
      let datos = { Id }; //localStorage.getItem("selectedDepartment");
      this.$swal({
        title: "¿Deseas eliminar este Area AYB?",
        text: "Se eliminará permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Departamentos-deleteDepartamento", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.getDepartamentosAB();
            this.$swal(
              "Area AYB eliminado",
              "El area se eliminó correctamente",
              "success"
            );
          } else {
            this.$swal(
              "Error deleting departamento",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    addDepartamento(datos) {
      this.$swal({
        title: "¿Deseas guardar la información del Area AYB?",
        text: "El Area AYB se almacenará y podrá empezar a usarse",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Departamentos-createDepartamento", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "El area AYB se guardó correctamente",
              icon: "success",
            }).then(() => {
              this.getDepartamentosAB();
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error guardando area AYB",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editDepartamento(datos) {
      this.$swal({
        title: "¿Deseas editar este area AYB?",
        text: "Los cambios se verán reflejados inmediatamente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Departamentos-updateDepartamento", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "El area AYB se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.getDepartamentosAB();
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error guardando area AYB",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getDepartamentosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Departamentos"
        );
      if (snapshot.exists()) {
        this.departamentos = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.departamentos.push(toAdd);
          }
        });
      }
    },
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.getDepartamentosAB();
  },
};
</script>
